import { concertName, instrumentToRole } from '../../consts/roundup';

import introOption from './slideOptions/introOption';
import bandRoleOption from './slideOptions/bandRoleOption';
import mediaOption from './slideOptions/imageOption';
import concertAttendanceOption from './slideOptions/concertAttendanceOption';
import songOption from './slideOptions/songOption';
import recentSkillsOption from './slideOptions/recentSkillsOption';
import skillsInProgressOption from './slideOptions/skillsInProgressOption';
import upcomingSkillsOption from './slideOptions/upcomingSkillsOption';
import skillsTotalOption from './slideOptions/skillsTotalOption';
import trinityGradeOption from './slideOptions/trinityGradeOption';
import trinityProgressOption from './slideOptions/trinityProgressOption';
import upcomingConcertOption from './slideOptions/upcomingConcertOption';
import outroPosterOption from './slideOptions/outroPosterOption';

import { preloadInstrumentAssets } from "../../utils/RoundUpUtils";

const ordering = {
  intro: 1,
  band_role: 2,
  media_1: 3,
  concert_attendance: 4,
  current_song: 5,
  skills_completed_since_last_roundup: 6,
  skills_in_progress: 7,
  skills_upcoming: 8,
  skills_completed: 9,
  media_2: 10,
  trinity_grade: 11,
  trinity_progress: 12,
  media_3: 13,
  upcoming_concert: 14,
  rating: 15,
  outro: 16,
}

const translateToSlide = (response) => {
  const {
    data
  } = response;

  if (!data) return null;

  const {
    id,
    attributes,
    links
  } = data;
  
  const {
    ac_year,
    ac_year_period,
    latest_band_media
  } = attributes;
  
  const {
    poster_image,
    song_asset
  } = links;

  const attributeData = attributes.data;

  const poster_share_url = `${window.location.origin}/round-up-poster?url=${poster_image}`
  
  const {
    kid_name,
    instrument,
    band_name,
    concerts_count,
    skills_completed,
    skills_completed_since_last_roundup,
    skills_in_progress,
    skills_upcoming,
    song_title,
    song_artist,
    next_concert_planned,
    stage_progress_percent,
    current_trinity_stage,
    trinity_opt_out
  } = attributeData;

  if (!kid_name) return null;
  
  const band_role = instrument && instrumentToRole[instrument];
  const hasDateInfo = ac_year_period && ac_year;
  const capitalize = s => (s && s[0].toUpperCase() + s.slice(1)) || ""
  const date = hasDateInfo && capitalize(`${ac_year_period}`);
  const nextConcertName = hasDateInfo && concertName[ac_year_period];
  // we are hardcoding this, note in notion to check & update next time
  const roundUpDateDisplay = date && `${date} Term 2025`

  const slides = [];
  const slideDesignators = [];

  // PRELOAD ASSETS
  if (latest_band_media) {
    latest_band_media.forEach((media) => {
      if (media.media_type === 'photo') {
        const img = new Image();
        img.src = media.photo_url;
      }
    });
  };

  preloadInstrumentAssets(instrument)

  // INTRO
  const intro_slide = introOption({date: roundUpDateDisplay, band_role, kid_name, ordering, instrument})
  if (intro_slide) {
    slides.push(intro_slide);
  }

  // BAND ROLE
  const band_role_slide = bandRoleOption({band_name, band_role, kid_name, ordering, instrument})
  if (band_role_slide) {
    slides.push(band_role_slide);
  }

  // MEDIA
  const media_slides = mediaOption({latest_band_media, kid_name, ordering})
  if (media_slides) {
    media_slides.forEach((slide) => slides.push(slide))
  }

  // CONCERT ATTENDANCE
  const concert_attendance_slide = concertAttendanceOption({concerts_count, kid_name, ordering, instrument})
  if (concert_attendance_slide) {
    slides.push(concert_attendance_slide);
  }

  // CURRENT SONG
  const current_song_slide = songOption({song_title, song_artist, song_asset, kid_name, ordering})
  if (current_song_slide) {
    slides.push(current_song_slide);
  }

  // SKILLS COMPLETE (since last roundup) - LISTED 
  const skills_complete_listed_slide = recentSkillsOption({skills_completed_since_last_roundup, ordering, instrument})
  if (skills_complete_listed_slide) {
    slides.push(skills_complete_listed_slide);
  }

  // SKILLS IN PROGRESS
  const skills_in_progress_slide = skillsInProgressOption({skills_in_progress, ordering, instrument})
  if (skills_in_progress_slide) {
    slides.push(skills_in_progress_slide);
  }

  // SKILLS UPCOMING - LISTED 
  const skills_upcoming_listed_slide = upcomingSkillsOption({skills_upcoming, ordering, instrument})
  if (skills_upcoming_listed_slide) {
    slides.push(skills_upcoming_listed_slide);
  }

  // SKILLS COMPLETED (accumulative) - COUNT
  const skills_complete_count_slide = skillsTotalOption({skills_completed, kid_name, ordering})
  if (skills_complete_count_slide) {
    slides.push(skills_complete_count_slide);
  }

  // TRINITY STAGE
  const trinity_enrollment_slide = trinityGradeOption({kid_name, ordering, current_trinity_stage, stage_progress_percent, trinity_opt_out})
  if (trinity_enrollment_slide) {
    slides.push(trinity_enrollment_slide);
  }
  
  // TRINITY PROGRESS
  const trinity_progress_slide = trinityProgressOption({stage_progress_percent, kid_name, ordering, current_trinity_stage, trinity_opt_out})
  if (trinity_progress_slide) {
    slides.push(trinity_progress_slide);
  }

  // UPCOMING CONCERT
  const upcoming_concert_slide = upcomingConcertOption({next_concert_planned, nextConcertName, kid_name, ordering, band_name})
  if (upcoming_concert_slide) {
    slides.push(upcoming_concert_slide);
  }
     
  // POSTER OUTRO
  const outro_slide = outroPosterOption({kid_name, ordering, poster: poster_image, poster_share_url})
  if (outro_slide) {
    slides.push(outro_slide);
  }
  
  slides.sort((a,b) => a.order - b.order)
  slides.forEach((slide) => {
    slideDesignators.push(slide.tracking)
  })

  return  {
    id,
    instrument,
    slides,
    roundUpDateDisplay,
    tracking: {
      slides_count: slides.length,
      slide_designators: slideDesignators
    }
  }
}

export default translateToSlide;
